import useTranslation from 'next-translate/useTranslation';

import log from '~/common/utils/log';
import useOpenIntercom from '~/components/Intercom/useOpenItercom';
import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

export const useShowCommissionerEmailListPopup = () => {
  const { t } = useTranslation('common');
  const message = t('getEmailListIntercom');
  const isMobile = useIsMobile();
  const { openIntercom, isIntercomAvailable } = useOpenIntercom();

  const showIntercom = () => {
    if (!isMobile && isIntercomAvailable) {
      openIntercom(message);
    } else {
      log('Intercom not available');
    }
  };

  return showIntercom;
};
